module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_LSCM.21317d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_LSCM.png
// module id = 60
// module chunks = 0